import React, { useEffect } from 'react'
import GuestLayout from '../../components/layouts/guest_layout'
import KyosoUserPolicyContent from './content/kyoso_user_policy_content'

/**
 * 利用規約ページ
 * SDGs 共創 Lodgeの利用規約を表示
 */
const PolicyUserPage: React.FC = () => {
  // ページ読み込み時にトップにスクロール
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <GuestLayout>
      <div className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg w-full py-12 px-4 sm:px-16 max-w-5xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 text-main-green">
              利用規約
            </h1>
          </div>
          <KyosoUserPolicyContent />
        </div>
      </div>
    </GuestLayout>
  )
}

export default PolicyUserPage
